var React = require('react');

function DownloadInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M0 14.5122L1.3125 13.2013L10.5 22.3781L19.6875 13.2013L21 14.5122L10.5 25L0 14.5122Z","fill":"black","key":0}),React.createElement("path",{"d":"M9.54545 0V24.0168H11.4545V0H9.54545Z","fill":"black","key":1})]);
}

DownloadInline.defaultProps = {"width":"21","height":"25","viewBox":"0 0 21 25","fill":"none","preserveAspectRatio":"xMidYMid"};

module.exports = DownloadInline;

DownloadInline.default = DownloadInline;
